<form edlFocusTrap [formGroup]="modifyDueDateForm"
      (ngSubmit)="submit(modifyDueDateForm)">
    <div class="modal-header">
        <h4 class="modal-title">Modify Follow-Up Due Date</h4>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-12" *ngIf="hasReachedFollowUpStage">
                                <div class="form-group">
                                    <label id="shouldSendNotificationsLabel"><strong>Send Email Notifications</strong></label>
                                    <button type="button" class="btn btn-link p-0 border-0 align-baseline"
                                            data-skip-initial-focus
                                            [ngbPopover]="sendEmailNotificationsContent"
                                            popoverTitle="Send Email Notifications"
                                            triggers="mouseenter:mouseleave focus:blur"
                                            aria-label="More information about Send Email Notifications">
                                        <i class="fas fa-info-circle ms-1" aria-hidden="true"></i>
                                    </button>
                                    <ng-template #sendEmailNotificationsContent>
                                        When selected, an email will be sent to the user notifying them.
                                    </ng-template>
                                    <toggle-indicator
                                            class="d-block"
                                            formControlName="ShouldSendNotifications"
                                            ariaLabelledBy="shouldSendNotificationsLabel"
                                            OnLabel="Yes" OffLabel="No"></toggle-indicator>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <edl-floating-label-container label="Due Date">
                                        <edl-date-picker formControlName="ModifyDueDate"></edl-date-picker>
                                    </edl-floating-label-container>
                                </div>
                            </div>
                            <div class="col-sm-12" *ngIf="hasReachedFollowUpStage && modifyDueDateForm.get('ShouldSendNotifications').value">
                                <div class="form-group">
                                    <label for="modifyDateNote"><strong>Note to User:</strong></label>
                                    <button type="button" class="btn btn-link p-0 border-0 align-baseline"
                                            data-skip-initial-focus
                                            [ngbPopover]="noteUserContent"
                                            popoverTitle="Note to User"
                                            triggers="mouseenter:mouseleave focus:blur"
                                            aria-label="More information about Note to User">
                                        <i class="fas fa-info-circle ms-1" aria-hidden="true"></i>
                                    </button>
                                    <ng-template #noteUserContent>
                                        If you would like to include a note in the email, enter it here.
                                    </ng-template>
                                    <textarea id="modifyDateNote" class="form-control" formControlName="Note" rows="3" placeholder="Comments here ..."></textarea>
                                </div>
                            </div>
                            <div class="col-sm-12" *ngIf="!hasReachedFollowUpStage">
                                <small class="text-muted no-notification-message">
                                    Note: No email notification is sent when the due date is modified at this time. The user is notified of the due date when the follow-up stage begins.
                                </small>
                            </div>
                        </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary"
                [disabled]="modifyDueDateForm.invalid"
                [ladda]="busy">Save & Close</button>
        <button type="button" class="btn btn-info"
                (click)="cancel()">Cancel</button>
    </div>
</form>
